<template>
  <v-layout>
    <v-app-bar elevation="0" class="border-b px-4">
      <v-app-bar-nav-icon
        variant="text"
        @click.stop="drawer = !drawer"
        class="mx-0"
      ></v-app-bar-nav-icon>
      <v-toolbar-title @click="navigateTo('/pembelajaran-wajib')">
        <v-img height="48px" width="106px" src="/images/logo.png"
      /></v-toolbar-title>
      <v-spacer></v-spacer>
      <template v-if="$vuetify.display.mdAndUp">
        <AccountBelajarWajib />
        <v-menu width="254">
          <template v-slot:activator="{ props }">
            <v-btn
              icon="mdi-chevron-down"
              variant="text"
              v-bind="props"
            ></v-btn>
          </template>
          <v-list>
            <v-list-item title="Keluar" @click="logoutBelajarWajib">
              <template v-slot:prepend>
                <v-icon icon="mdi-logout"></v-icon>
              </template>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
      <v-menu v-else width="254">
        <template v-slot:activator="{ props }">
          <v-btn icon="mdi-dots-vertical" variant="text" v-bind="props"></v-btn>
        </template>
        <v-list>
          <AccountBelajarWajib class="mb-2" />
          <v-divider></v-divider>
          <v-list-item title="Keluar" @click="logoutBelajarWajib">
            <template v-slot:prepend>
              <v-icon icon="mdi-logout"></v-icon>
            </template>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-navigation-drawer
      v-model="drawer"
      :location="$vuetify.display.mobile ? 'bottom' : 'left'"
      :touchless="$vuetify.display.mobile"
      class="border-0 bg-white pt-4"
      width="300"
      elevation="3"
    >
      <v-list color="blue-accent-4" class="mb-4">
        <v-list-item
          v-for="(link, linkId) in navbarLink"
          :key="linkId"
          :prepend-icon="link.icon"
          :title="link.name"
          :to="`${link.to}?batchId=${batchId}`"
          class="px-7"
        ></v-list-item>
      </v-list>
      <template v-slot:append>
        <v-divider></v-divider>
        <div class="text-center pa-2 text-caption">
          Portal Pembelajaran Wajib
          <div class="text-medium-emphasis">
            Lembaga Administrasi Negara — {{ new Date().getFullYear() }}
          </div>
        </div>
      </template>
    </v-navigation-drawer>
    <v-main class="bg-grey-lighten-5">
      <v-container
        fluid
        class="px-4 px-md-8"
        style="min-height: calc(var(--vh, 1vh) * 100)"
      >
        <v-row>
          <BreadcrumsBelajarWajib />
          <NuxtPage />
        </v-row>
      </v-container>
    </v-main>
  </v-layout>
</template>
<script>
import BreadcrumsBelajarWajib from "~/components/pembelajaran_wajib/shared/BreadcrumsBelajarWajib";
import AccountBelajarWajib from "~/components/pembelajaran_wajib/shared/AccountBelajarWajib";

export default {
  components: {
    BreadcrumsBelajarWajib,
    AccountBelajarWajib,
  },
  data: () => ({
    drawer: null,
    navbarLink: [
      {
        name: "Agenda",
        to: "/pembelajaran-wajib/terintegrasi",
        icon: "mdi-view-dashboard-outline",
      },
      {
        name: "Evaluasi Akademik",
        to: "/pembelajaran-wajib/terintegrasi/evaluasi-akademik",
        icon: "mdi-clipboard-text-clock",
      },
      {
        name: "Inovasi",
        to: "/pembelajaran-wajib/terintegrasi/inovasi",
        icon: "mdi-lightbulb-on-outline",
      },
      {
        name: "Profil Peserta",
        to: "/pembelajaran-wajib/terintegrasi/profil",
        icon: "mdi-account",
      },
      {
        name: "Pusat Bantuan",
        to: `/pusat-bantuan`,
        icon: "mdi-face-agent",
      },
    ],
  }),
  computed: {
    batchId() {
      return useRoute().query.batchId;
    },
    courseDetail() {
      return useBelajarWajibTerjadwalStore().courseDetail;
    },
  },
  methods: {
    logoutBelajarWajib() {
      useBelajarWajibStore().clearTokens();
      return navigateTo({ path: "/pembelajaran-wajib/login" });
    },
  },
};
</script>
